import request from 'superagent';
import store from '../app/store';

export function executeRequest(url, args, faillureCallback, successCallback) {
	const am_i_logged_in = __COM__
		? false
		: store.getState().user.firstname ? true : false;

	const argsWithGuest = {
		...args,
		am_i_logged_in
	};

	request
		.post(url)
		.type('form')
		.send(argsWithGuest)
		.withCredentials()
		.end(function(err, res) {
			// Network error
			if (err) {
				return;
			}

			// API return no body
			if (!res.body) {
				store.dispatch({
					type: 'ERROR',
					errorText: res.text
				});
				faillureCallback(res.text);
				return;
			}

			const response = res.body;

			// API Error
			if (response.state === 'error' || response.state === 'exception') {
				// NOTE: need strict equality because API return "?" as value for session_expired
				if (response.session_expired === true) {
					store.dispatch({ type: 'SESSION_EXPIRED' });
					faillureCallback(res.body.error);
					return;
				}
				const errorText = response.error;
				store.dispatch({ type: 'ERROR', errorText });
				faillureCallback(res.body.error);
				return;
			}

			if (response.state === 'done') {
				successCallback(res.body.result);
			}
		});
}



// WEBPACK FOOTER //
// ./src/js/webAPI/request.js